<template>
  <header class="admin-exclusive-toolbar">
    <div class="admin-exclusive-toolbar__copy">
      <p class="admin-exclusive-toolbar__eyebrow admin-exclusive-toolbar__description">Curadoria editorial</p>
      <h1 class="admin-exclusive-toolbar__title">{{ title }}</h1>
      <p class="admin-exclusive-toolbar__subtitle admin-exclusive-toolbar__description">{{ subtitle }}</p>
      <div class="admin-exclusive-toolbar__stats" aria-label="Resumo da curadoria">
        <v-chip small dark color="var(--zinnes-primary)">{{ total }} obras</v-chip>
        <v-chip small dark color="#2e7d32">{{ activeCount }} ativas</v-chip>
        <v-chip v-if="inactiveCount" small dark color="#616161">{{ inactiveCount }} inativas</v-chip>
      </div>
    </div>

    <div class="admin-exclusive-toolbar__actions">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="admin-exclusive-icon-btn"
            :loading="loading"
            :disabled="saving"
            aria-label="Recarregar exclusivos"
            v-bind="attrs"
            v-on="on"
            @click="$emit('refresh')"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Recarregar</span>
      </v-tooltip>

      <v-btn
        class="admin-exclusive-toolbar__add zinnes-primary-btn"
        dark
        :disabled="loading || saving"
        @click="$emit('open-search')"
      >
        <v-icon left>mdi-plus</v-icon>
        Adicionar obra
      </v-btn>

      <v-btn
        outlined
        dark
        class="admin-exclusive-toolbar__save"
        :loading="saving"
        :disabled="loading || !canSave"
        @click="$emit('save-order')"
      >
        <v-icon left>mdi-content-save-outline</v-icon>
        Salvar ordem
      </v-btn>
    </div>
  </header>
</template>

<script>
export default {
  name: "AdminExclusiveProjectToolbar",
  props: {
    title: { type: String, default: "Exclusivos da Home" },
    subtitle: {
      type: String,
      default: "Escolha as obras que aparecem na secao Exclusivos e organize a ordem exibida na home.",
    },
    total: { type: Number, default: 0 },
    activeCount: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    canSave: { type: Boolean, default: true },
  },
  computed: {
    inactiveCount() {
      return Math.max(this.total - this.activeCount, 0);
    },
  },
};
</script>

<style src="../../../styles/home-page/admin.css"></style>
